import React, { Component } from 'react';
import SakuraOrbit from './SakuraOrbit';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';
import SakuraSep from './SakuraSep';

const rpc = new DataRPC();

const CATEGORY = { 1: 'Sự Kiện', 2: 'Thông Báo', 3: 'Tuyển Sinh', 4: 'Tin Tức' };

function formatDate(str) {
    if (!str) return '';
    const d = new Date(str);
    return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
}

class NewsDetail extends Component {
    state = { article: null, loading: true, notFound: false };

    componentDidMount() {
        const { slug } = this.props.match.params;
        // Posts without a slug are linked as /news/<id>. Pick the lookup up front:
        // fetchRawData never settles when the API returns an empty result, so a
        // "try slug, then id" fallback would hang on the first call.
        rpc.fetchRawData('GetNews1', /^\d+$/.test(slug) ? { id: slug } : { slug })
            .then(article => {
                if (!article || !article.id) {
                    this.setState({ loading: false, notFound: true });
                } else {
                    this.setState({ article, loading: false });
                }
            })
            .catch(() => this.setState({ loading: false, notFound: true }));
    }

    render() {
        const { article, loading, notFound } = this.state;
        const showNotFound = !loading && (notFound || !article);

        const catLabel = article ? (CATEGORY[article.type] || 'Tin Tức') : '';
        const dateStr  = article ? formatDate(article.published_at || article.created_at) : '';

        return (
            <>
                {article && (
                    <PageMeta
                        title={article.title}
                        description={article.short_description || article.title}
                        image={article.avatar_url ? `https://s3.ap-southeast-1.amazonaws.com/vietnamyosakoi-resources/${article.avatar_url}` : undefined}
                        url={`/news/${article.slug}`}
                        type="article"
                    />
                )}

                <div
                    className="page-header nwd-page-header"
                >
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">TIN TỨC</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{ margin: 0 }} />

                <div className="nwd-body">
                    <div className="container">

                        {loading ? (
                            <div className="nwd-loading">
                                <SakuraOrbit label="Đang tải bài viết" />
                            </div>
                        ) : showNotFound ? (
                            <div className="nwd-not-found">
                                <div className="nwd-not-found-kanji">桜</div>
                                <h2>Không tìm thấy bài viết</h2>
                                <p>Bài viết không tồn tại hoặc đã bị xóa.</p>
                                <Link to="/news" className="nwd-back-btn">← Về Tin Tức</Link>
                            </div>
                        ) : (
                            <>
                                <div className="entry-title">
                                    <p>{catLabel}</p>
                                    <h2>CHI TIẾT BÀI VIẾT</h2>
                                </div>

                                <article className="nwd-article">
                                    {article.avatar_url && (
                                        <div className="nwd-featured-img">
                                            <img src={s3(article.avatar_url)} alt={article.title} />
                                        </div>
                                    )}

                                    <div className="nwd-article-inner">
                                        <h1 className="nwd-title">{article.title}</h1>
                                        <div className="nwd-meta-date">{dateStr}</div>

                                        {article.short_description && (
                                            <p className="nwd-excerpt">{article.short_description}</p>
                                        )}

                                        <div
                                            className="nwd-content"
                                            dangerouslySetInnerHTML={{ __html: article.content }}
                                        />
                                    </div>
                                </article>

                                <div className="nwd-footer">
                                    <Link to="/news" className="nwd-back-btn">← Quay lại Tin Tức</Link>
                                </div>
                            </>
                        )}

                        <SakuraSep />
                    </div>
                </div>

                <div className="sep-gold-rule" style={{ margin: 0 }} />
            </>
        );
    }
}

export default NewsDetail;
